import loggingService from '@/services/util/loggingService'
import dateService from '@/services/util/dateService'

var serviceName = 'caseNarrativeService'
var path = '/CaseNarrative/'
var isDebug = false

function put (http, dto) {
    loggingService.log(isDebug, serviceName, 'put')
    return http.put(path + 'Put', dto)
}

function get (http, caseNarrativeId) {
    loggingService.log(isDebug, serviceName, 'get')
    return http.get(path + 'Get?caseNarrativeId=' + caseNarrativeId)
}

function listCaseNarrativeOwners (http, caseId) {
    loggingService.log(isDebug, serviceName, 'listCaseNarrativeOwners')
    return http.get(path + 'ListCaseNarrativeOwners?caseId=' + caseId)
}

function listUserNarrativeByCaseId (http, caseId) {
    loggingService.log(isDebug, serviceName, 'listUserNarrativeByCaseId')
    return http.get(path + 'ListUserNarrativeByCaseId?caseId=' + caseId).then(response => {
        if (response.data) {
            response.data.forEach(x => {
                x.createdDate = dateService.toDateTimeString(x.createdDate)
                x.modifiedDate = dateService.toDateTimeString(x.modifiedDate)
            })
        }
        return response
    }).catch(error => {
        throw error
    })
}

function listOtherUserNarratives (http, caseId) {
    loggingService.log(isDebug, serviceName, 'listOtherUserNarratives')
    return http.get(path + `ListOtherUserNarratives?caseId=${caseId}`).then(response => {
        if (response.data) {
            response.data.forEach(x => {
                x.createdDate = dateService.toDateTimeString(x.createdDate)
                x.modifiedDate = dateService.toDateTimeString(x.modifiedDate)
            })
        }
        return response
    }).catch(error => {
        throw error
    })
}

function assignAndCreate (http, dto) {
    loggingService.log(isDebug, serviceName, 'AssignAndCreate')
    return http.post(path + 'AssignAndCreate', dto)
}

function reassignNarrative (http, dto) {
    loggingService.log(isDebug, serviceName, 'reassignNarrative')
    return http.post(path + 'ReassignNarrative', dto)
}

export default {
    put: put,
    get: get,
    listCaseNarrativeOwners: listCaseNarrativeOwners,
    listUserNarrativeByCaseId: listUserNarrativeByCaseId,
    listOtherUserNarratives: listOtherUserNarratives,
    assignAndCreate: assignAndCreate,
    reassignNarrative: reassignNarrative
}
